<template>
  <div class="lawsTable">
    <el-table
      :data="data"
      border
      stripe
      @cell-click="clickCell"
      :cell-class-name="setCellHighlight"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading">
      <el-table-column
        type="index"
        :index="1"
        label="序号"
        header-align="center"
        align="center"
        class-name="bold"
        :min-width="'40'">
      </el-table-column>
      <!-- 主体 -->
      <el-table-column v-for="col in columns"
        :prop="col.id"
        :key="col.id"
        :label="col.label"
        :min-width="col.width"
        :align="col.align || 'center'"
        header-align="center">
      </el-table-column>
      <!-- 操作 -->
      <el-table-column label="下载" :width="45" header-align="center">
        <template slot-scope="scope">
          <img @click="clickDownload(scope.$index)" src="@/assets/download_blue.png" class="icon">
        </template>
      </el-table-column>
      <el-table-column label="阅读" :width="45" header-align="center">
        <template slot-scope="scope">
          <img @click="clickRead(scope.$index)" src="@/assets/read.png" class="icon">
        </template>
      </el-table-column>
      <el-table-column label="收藏" :width="45" header-align="center">
        <template slot-scope="scope">
          <img @click="clickCancelCollect(scope.row)" src="@/assets/star2.png" v-if="_isCollected(scope.row[0])" class="icon">
          <img @click="clickCollect(scope.row)" src="@/assets/star.png" v-else class="icon">
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'lawsTable',
  data() {
    return {
      columns: [
        {id: '1', label: '题目', width: 140, align: 'left'},
        {id: '2', label: '作者', width: 95},
        {id: '3', label: '刊名', width: 75},
        {id: '4', label: '发表时间', width: 50},
        {id: '5', label: '数据库', width: 40},
        {id: '6', label: '被引', width: 40},
      ],
    }
  },
  computed: {
    collectionsId() {
      return this.collections.map(item => item[0])
    }
  },
  props: {
    // [[${id}, ${title}, ${authors}, ...(As define in UE)], ...]
    data: {
      type: Array,
      required: true,
    },
    collections: {
      type: Array,
      required: true
    },
    loading: Boolean
  },
  methods: {
    clickDownload(index) {
      // downloadUrl在data最后一位
      if (this.data[index][this.data[index].length - 1]) {
        window.open(this.data[index][this.data[index].length - 1])
      } else {
        if (localStorage.Authorization) {
          alert('管理员未提供下载文件')
        } else {
          alert('登录后才可以下载')
        }
      }
    },
    clickCell(row, col) {
      if (col.label === '题目') {
        this.$router.push({name: 'casesDetail', query: {id: row[0]}})
      }
    },
    clickRead(index) {
      this.$router.push({name: 'casesDetail', query: {id: this.data[index][0]}})
    },
    _isCollected(id) {
      return this.collectionsId.findIndex(item => item === id) !== -1
    },
    async clickCollect(row) {
      if (!localStorage.Authorization) {
        alert('登陆后才可以收藏')
      } else {
        const code = await this.$net.dataAndCases.collect(row[0])
        if (code) {
          alert('收藏失败，错误码' + code)
        } else {
          alert('收藏成功')
          this.$emit('collect')
        }
        // this.$store.commit('addCaseCollection', row)
      }
    },
    async clickCancelCollect(row) {
      const code = await this.$net.dataAndCases.cancelCollect(row[0])
      if (code) {
        alert('取消收藏失败，错误码' + code)
      } else {
        alert('取消收藏成功')
        this.$emit('collect')
      }
      // this.$store.commit('removeCaseCollection', row[0])
    },
    setCellHighlight(conf) {
      if (conf.columnIndex === 1) {
        return 'cellHighlight'
      }
    }
  }
}
</script>

<style lang="scss">

  .lawsTable {
    width: 100%;
    .el-table {
      width: 100%;
    }
    // 此样式为解决表头错位问题
    .el-table th.gutter{
      display: table-cell!important;
    }
    .el-table__header tr th {
      background: #d7d7d7;
      color: #000;
      font-weight: normal;
    }
    .icon {
      width: 20px;
      height: 20px;
      margin: 0 auto;
      display: inherit;
      cursor: pointer;
    }
  }
  .cellHighlight {
    cursor: pointer;
    &:hover {
      color: $standard-blue;
    }
  }
  .bold {
    font-weight: bold;
  }

</style>